import React, { useEffect, useState } from "react";
import CardInfo from "../../components/cards/cardInfo";
import DivisionCmp from "../../components/cards/DivisionCmp";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import { useMutation } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomisedButton from "../../components/button/button";
import CollapseCardHintCmp from "../../components/cardHint/collapseCardHintCmp";
import TwoColumnCard from "../../components/cards/TwoColumnCard";
import FileUploader from "../../components/dropzone/FileUploader";
import ShowErrorsModal from "../../components/modals/showErrorsModal";
import TableCreator from "../../components/table/tableCreator";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import LoadDocumentCmp from "../../components/thumbnail/loadDocumentCmp";
import { SALE_ITEM } from "../../config/cacheKey";
import { GetDocumentTypesResponse } from "../../models/basicInformation.model";
import { ColumnModel } from "../../models/common.model";
import {
  IDeleteInvoiceFileRequest,
  IGetByKeyResponse,
  IInvoiceFiles,
  ISaleItemRequest,
  IUploadInvoiceFileRequest,
  IWaitForConfirmRequestRequest,
} from "../../models/sale.model";
import { ErrorsTab } from "../../models/supplierSettlement/supplierSettlement.model";
import { getDocumentTypes } from "../../services/basicInformation.service";
import {
  deleteInvoiceFile,
  getByKey,
  uploadInvoiceFile,
  waitForConfirmRequest,
} from "../../services/sale.service";
import "./sale.css";
// const [attachments, setAttachments] = useState<IInvoiceFiles[]>([]);

export default function SaleFactorFilesStep() {
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = React.useState<IGetByKeyResponse>();
  const [error, setError] = React.useState([] as ErrorsTab[]);
  const [factorNumber, setFactorNumber] = React.useState<string>("");
  const [invoiceFile, setInvoiceFile] = useState<IInvoiceFiles[]>([]);
  const history = useHistory();
  const columns: readonly ColumnModel[] = [
    { id: "saleItemGroupTitle", label: "گروه کالا" },
    { id: "title", label: " عنوان کالا" },
    { id: "quantity", label: " مقدار (عدد)" },
    {
      id: "saleItemTotalAmount",
      label: " مبلغ کل (ريال)",
      hasFormat: true,
      format: (value: number) => {
        return value?.toLocaleString("fa");
      },
    },
  ];
  const table = (
    <Box paddingX={{ md: "2rem" }}>
      <TableCreator
        columns={columns}
        data={data?.saleItems}
        pageInfo={undefined}
        // handleChangePagination={handleChangePagination}
        // currentPaginationInfo={currentPaginationInfo}
      />
    </Box>
  );
  const hints = [
    <>
      جهت تسریع در فرآیند تسویه میتوانید{" "}
      <b style={{ color: "#2962FF" }}>تصویر فاکتور فروش</b> را در این مرحله
      بارگذاری نموده و بر روی{" "}
      <b style={{ color: "#2962FF" }}>دکمه درخواست تسویه</b> کلیک کنید.
    </>,
    <>
      در صورتی که امکان بارگذاری فاکتور فروش در این لحظه برای شما میسر نمیباشد،
      میتوانید با مراجعه به منوی{" "}
      <b style={{ color: "#2962FF" }}>"درخواست تسویه"</b> نسبت به تکمیل پرونده و
      صدور درخواست تسویه اقدام نمایید .
    </>,
    <>
      فاکتور بارگذاری شده میبایست دارای{" "}
      <b style={{ color: "#2962FF" }}>تمامی اطلاعات فروشنده و متقاضی</b> باشد، و{" "}
      <b style={{ color: "#2962FF" }}>ممهور به مهر فروشگاه</b> باشد.
    </>,
  ];
  const handleShowError = () => {
    setOpenModal(true);
  };
  interface IGetSaleId {
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }
  let request = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;
  useEffect(() => {
    GetByKeyMutate({
      saleKey: request?.saleKey!,
      branchId: request?.branchId!,
      customerPersonId: request?.customerPersonId!,
    });
  }, []);
  const location = useLocation();
  useEffect(() => {
    const handleBackButton = (event: any) => {
      event.preventDefault();
      if (location.pathname.includes("/sale/SaleFactorFilesStep")) {
        history.push("/sale/customerInquiry");
      }
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [history]);
  const { mutate: GetByKeyMutate } = useMutation(getByKey, {
    onSuccess: (data: IGetByKeyResponse) => {
      if (data) {
        setData(data);
        setFactorNumber(data.factoreNumber);
        setInvoiceFile(data.invoiceFiles);
      }
    },
  });
  const { mutate: waitForConfirmRequestMutation } = useMutation(
    waitForConfirmRequest,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success("درخواست  با موفقیت انجام شد.");
          history.push(`/sale/AwaitedSettelmentSales`);
        }
      },
    }
  );
  return (
    <div>
      <CardInfo
        customerFullName={data?.customerFullName}
        customerMobileNumber={data?.customerMobileNumber}
        customerWalletAmount={data?.customerWalletAmount}
        expirationDate_Persian={data?.expirationDate_Persian}
        saleDate_Persian={data?.saleDate_Persian}
        issuanceInvoiceDate_Persian={data?.issuanceInvoiceDate_Persian}
        confirmInvoiceDate_Persian={data?.confirmInvoiceDate_Persian}
        branchAddress={data?.branchAddress}
        saleType={data?.saleType}
        saleTypeTitle={data?.saleTypeTitle}
        branchTitle={data?.branchTitle}
        storeTitle={data?.storeTitle}
        storeUrl={data?.storeUrl}
      />
      {data?.rejectReasons && data?.rejectReasons?.length > 0 && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 4, sm: 6, md: 12 }}
          style={{
            background: `#FFDCE0`,
            fontFamily: "iranSans",
            textAlign: "center",
            alignItems: "center",
            verticalAlign: "middle",
            padding: "2vh",
            width: "98%",
            margin: "0 auto",
            border: "1px solid #C1C7CB",
            borderRadius: "5px",
          }}
        >
          <Grid xs={12}>
            <span style={{ fontSize: "16px" }} className="SuccessDefaultFont">
              درخواست تسویه حساب شما تایید نشده است. برای مشاهده خطاها روی
              <b className="colorRed cursorPointer" onClick={handleShowError}>
                &nbsp;"مشاهده جزییات"
              </b>{" "}
              کلیک کنید.
            </span>
          </Grid>
        </Grid>
      )}
      <div className="mTop30">
        <DivisionCmp title="کالاهای درخواستی" child={table} />
      </div>
      <div style={{ width: "98%", margin: "0 auto" }}>
        <CollapseCardHintCmp
          icon={
            <WarningAmberRoundedIcon sx={{ color: "#1D4A87", fontSize: 19 }} />
          }
          hints={hints}
          textFontSize="12px"
        />
      </div>
      <Grid
        container
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="mTop30"
        style={{ width: "99%", margin: "0 auto" }}
        spacing={1}
      >
        <Grid item xs={6} sm={12} md={6}>
          <DivisionCmp
            title="جزییات پرداخت"
            child={
              <div
                className="p-5"
                style={{ maxHeight: "23.5rem", height: "23.5rem" }}
              >
                <TwoColumnCard
                  saleAmount={data?.saleAmount!}
                  cashAmount={data?.cashAmount!}
                  creditAmount={data?.creditAmount!}
                  totalSettlementAmount={data?.totalSettlementAmount!}
                />
              </div>
            }
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6}>
          <DivisionCmp
            style={{ height: "378px", minHeight: "378px", maxHeight: "378px" }}
            title="مستندات فاکتور"
            child={
              <div className="p-1">
                <PaymentConfirmation
                  setFactorNumber={setFactorNumber}
                  invoiceFile={invoiceFile}
                  setInvoiceFile={setInvoiceFile}
                  request={request!}
                  factorNumber={factorNumber}
                />
              </div>
            }
            minHeight="27rem"
            maxHeight="27rem"
            textAlign="center"
            alignItems="center"
          />
        </Grid>
      </Grid>
      {data?.rejectReasons! && data?.rejectReasons!.length > 0 && (
        <ShowErrorsModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          validationMessages={data?.rejectReasons!}
          firstPartOfTitle=" درخواست تسویه حساب به دلایل زیر"
          boldTitle="پذیرفته"
          secondPartOfTitle="نشد.جهت ویرایش به بخش های مربوطه مراجعه کنید."
        />
      )}
      <Grid
        container
        style={{
          paddingBottom: "20px",
        }}
      >
        <Grid item sm={6}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <Grid xs={12} sm={3}>
            <CustomisedButton
              title={" درخواست تسویه حساب"}
              disable={factorNumber && invoiceFile?.length !== 0 ? false : true}
              onClick={() => {
                waitForConfirmRequestMutation({
                  saleKey: request?.saleKey!,
                  branchId: request?.branchId!,
                  customerPersonId: request?.customerPersonId!,
                  factorNumber: factorNumber!,
                });
              }}
              type="submit"
            />
          </Grid>
          <Grid xs={12} sm={3}>
            <CustomisedButton
              title={"بازگشت"}
              disable={false}
              onClick={() => {}}
              type="submit"
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

const PaymentConfirmation = ({
  setFactorNumber,
  invoiceFile,
  setInvoiceFile,
  request,
  factorNumber,
}: {
  setFactorNumber: React.Dispatch<React.SetStateAction<string>>;
  invoiceFile: IInvoiceFiles[];
  setInvoiceFile: React.Dispatch<React.SetStateAction<IInvoiceFiles[]>>;
  request: ISaleItemRequest;
  factorNumber: string;
}) => {
  const [number, setNumber] = useState<string>(factorNumber);
  const [maxSizeKB, setMaxSizeKB] = useState<number>();
  const [fileExtensions, setFileExtensions] = useState<string[]>([]);
  useEffect(() => {
    GetDocumentTypesMutation();
  }, []);
  useEffect(() => {
    setNumber(factorNumber);
  }, [factorNumber]);
  const validationFatcorNumber = Yup.object().shape({
    inquiryOtp: Yup.string()
      .required("فیلد اجباری است.")
      .matches(/^[0-9]+$/, "کد استعلامی عدد می باشد."), //.min(5).max(5)
  });
  const { mutate: GetDocumentTypesMutation } = useMutation(getDocumentTypes, {
    onSuccess: (data: GetDocumentTypesResponse[]) => {
      if (data) {
        const documentType = data.filter(
          (item: any) => item.documentType === "SalesFactor"
        );
        setMaxSizeKB(documentType[0].maxSizeKb);
        setFileExtensions(documentType[0].fileExtensions);
      }
    },
  });

  function handleChoosedImage(image: any) {
    let maxSize = maxSizeKB! * 1024;
    if (maxSize === undefined) {
      maxSize = 1024 * 1000;
    }

    if (image.data.size != null && image.data.size > maxSize) {
      toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
      return;
    } else if (fileExtensions?.includes(image.data.type)) {
      const uploadInvoiceFileObj = {} as IUploadInvoiceFileRequest;
      uploadInvoiceFileObj.saleKey = request.saleKey;
      uploadInvoiceFileObj.branchId = request.branchId;
      uploadInvoiceFileObj.customerPersonId = request.customerPersonId;
      uploadInvoiceFileObj.file = image.data;
      uploadInvoiceFileMutation(uploadInvoiceFileObj);
    } else {
      toast.warning("نوع فایل بارگذاری شده مجاز نمی باشد");
    }
  }
  function handleOnFileChoosed(files: any) {
    if (files.length === 0) return;
    let maxSize = maxSizeKB! * 1024;
    if (maxSize === undefined) {
      maxSize = 1024 * 1000;
    }
    //convert KB to Byte--> size returns byte of size
    if (files[0]?.size !== null && files[0]?.size > maxSize) {
      toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
      // return null;
    } else if (fileExtensions?.includes(files[0]?.type)) {
      let fileObj = {} as IInvoiceFiles;
      fileObj.fileUrl = files[0]?.preview;
      fileObj.fileName = files[0]?.name;
      fileObj.fileId = files[0]?.fileId;
      fileObj.fileType = files[0]?.type;
      fileObj.documentTypeTitle = files[0]?.documentTypeTitle;
      const uploadInvoiceFileObj = {} as IUploadInvoiceFileRequest;
      uploadInvoiceFileObj.saleKey = request.saleKey;
      uploadInvoiceFileObj.branchId = request.branchId;
      uploadInvoiceFileObj.customerPersonId = request.customerPersonId;
      uploadInvoiceFileObj.file = files[0];
      uploadInvoiceFileMutation(uploadInvoiceFileObj);
    } else {
      toast.warning("نوع فایل بارگذاری شده مجاز نمی باشد");
    }
  }

  const setChildValue = (childValues: any) => {
    setInvoiceFile(childValues);
  };
  let uploadFile: IInvoiceFiles[] = [];
  const { mutate: uploadInvoiceFileMutation } = useMutation(uploadInvoiceFile, {
    onSuccess: (data: IInvoiceFiles) => {
      if (data) {
        if (data !== null && data !== undefined) {
          let fileObj = {} as IInvoiceFiles;
          fileObj.fileUrl = data.fileUrl;
          fileObj.fileName = data.fileName;
          fileObj.fileId = data.fileId;
          fileObj.fileType = data.fileType;
          fileObj.documentTypeTitle = data.documentTypeTitle;
          if (invoiceFile !== null) {
            uploadFile = [...invoiceFile, fileObj];
          } else {
            uploadFile.push(fileObj);
          }
          setInvoiceFile(uploadFile);
        }
      }
    },
  });

  const handleChangeFactorNumber = (e: any) => {
    if (e.target?.value !== undefined && e.target?.value !== null) {
      setFactorNumber(e.target?.value!);
      setNumber(e.target?.value!);
    }
  };

  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (event.target.value.length >= 50 && key !== 8 && key !== 46) {
      event.preventDefault();
    }
  };

  return (
    <Formik
      validateOnMount={true}
      initialValues={{} as IWaitForConfirmRequestRequest}
      validationSchema={validationFatcorNumber}
      onSubmit={async (values) => {}}
    >
      {({
        handleSubmit,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
      }) => (
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "90%",
            margin: "0px auto",
            maxHeight: "25rem",
            overflowY: "hidden",
            overflowX: "auto",
          }}
        >
          <div>
            <Typography style={{ textAlign: "right" }}>
              <span>
                <b>شماره</b> فاکتور فروش و <b>تصاویر</b> فاکتور را وارد کنید.
              </span>
            </Typography>
          </div>
          <Grid container xs={12} style={{ marginTop: "30px" }}>
            <Grid item xs={12} style={{ maxWidth: "34rem" }}>
              <MaterialTextFieldComponent
                autoFocus={false}
                helperText={touched.factorNumber ? errors.factorNumber : ""}
                error={touched.factorNumber && Boolean(errors.factorNumber)}
                placeHolder={" شماره فاکتور"}
                label={" شماره فاکتور"}
                required={true}
                value={number}
                onChange={handleChangeFactorNumber}
                onBlur={handleBlur}
                name="factorNumber"
                id="factorNumber"
                autoComplete="off"
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid
              container
              xs={12}
              style={{ marginTop: "30px", overflow: "auto" }}
            >
              <Grid item xs={6} style={{ maxWidth: "18rem" }}>
                <FileUploader
                  handleImageSubmit={(e: any) => handleChoosedImage(e)}
                  handleOtherFiles={(e: any) => handleOnFileChoosed(e)}
                  fileTitle={"افزودن فاکتور"}
                  width="90%"
                  minWidth="90%"
                  marginRight="0px"
                  fileExtensions={fileExtensions}
                />
              </Grid>
              <Grid
                item
                xs={6}
                width={{ xs: "200px", lg: "unset" }}
                className="horizontalScroll"
              >
                {invoiceFile !== null && invoiceFile?.length > 0
                  ? invoiceFile?.map((item: any) => {
                      return (
                        <div
                          style={{
                            minWidth: "23vh",
                            maxWidth: "23vh",
                            display: "inline-block",
                          }}
                        >
                          <LoadDocumentCmp
                            data={item}
                            setChildValue={setChildValue}
                            serviceName={deleteInvoiceFile}
                            cacheName={undefined}
                            serviceRequestObj={
                              {
                                saleKey: request.saleKey,
                                branchId: request.branchId,
                                customerPersonId: request.customerPersonId,
                                fileId: item.fileId,
                              } as IDeleteInvoiceFileRequest
                            }
                            attachments={invoiceFile}
                            multiItem={true}
                            picName={"picName"}
                          />
                        </div>
                      );
                    })
                  : null}
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};
